module.exports = __webpack_public_path__ + "img/banner-2.4edb5b52.jpg";